import type { ReactNode } from 'react';

/** 內容卡（簡單佔位／內容容器）——顏色一律 token */
export default function Placeholder({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div
      className="max-w-md mx-auto rounded-xl p-6"
      style={{ background: 'var(--color-card)', boxShadow: 'var(--shadow-card)' }}
    >
      <h2 className="text-lg font-bold mb-2">{title}</h2>
      <div style={{ color: 'var(--color-text-secondary)' }}>{children}</div>
    </div>
  );
}
